<footer class="bg-primary footer oliverFooter" *ngIf = "router.url !== '/cart'  &&  router.url !== '/account/orders'  && 
    router.url !== '/account/addresses' && router.url !== '/account/payment/add-credit-card'">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="py-2 border-bottom-mute theme-container"> 
        <div fxFlex="100" fxLayoutGap = "15px" fxLayout ="row" fxLayout.xs ="column" [fxFlex.gt-sm]="logoWidth" ngClass.sm="mt-2" ngClass.xs="mt-2" *ngIf = "storeDetailsJson['footer']"> 
            <div fxLayout = "column">
                <img class="footerLogo hand-hover" routerLink="/index" [src] ="storeDetailsJson['footer']['logos']['logoImage1']" alt = "Logo" />
            </div>
        </div>
        <div>
            <p *ngIf = "storeDetailsJson['second_footer']">{{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}</p>
        </div>
        <div class="socialIcons">
            <ul class="list-inline" fxLayout="row" fxLayoutGap="15px">
                <li *ngFor="let x of storeDetailsJson['socialMedia']; let i = index">
                      <a [href]="x.href" target="_blank" [class]="'soicon'+i">
                            <i [class]="'fa fa-'+x.icon" aria-label="socialmedia"></i>
                      </a>
                </li> 
          </ul>
        </div>
    </div>
    <ng-container *ngIf="!!featureTags && featureTags['ftag_powered_by_fds']">
        <div class="theme-container cookieSetting" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center">
            <p><i class="fa fa-link"></i>Cookie Settings</p>
            <a href="https://farmdeliverysoftware.com/" *ngIf="storeDetails.show_powered_by_link === 1" class="brandLink" target="_blank">Powered by Smart FDS</a>
        </div>
    </ng-container>
    <ng-container *ngIf="!!featureTags && !featureTags['ftag_powered_by_fds']">
        <div class="theme-container cookieSetting"><p><i class="fa fa-link"></i>Cookie Settings</p></div>
    </ng-container>
       
</footer>